import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";

const Filters = ({ setFilters, filters }) => {
    const { alarmStatisticsQuestions, alarmStatisticsPCL, alarmStatisticsType } = useReportFiltersFetch({ fetchAlarmStatisticsQuestions: true, fetchAlarmStatisticsPCL: true, fetchAlarmStatisticsType: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>

                    <InputForm
                        id="plate"
                        label="Placa"
                        mask={MaskDefault.plateNoRestrict}
                        value={filters.plate}
                        onChange={({target}) => setFilters(prev => ({...prev, plate: target?.value?.toUpperCase()}))}
                    />

                    <SelectComponent
                        id="pcl"
                        label='Ponto de coleta'
                        isMulti={true}
                        wrapValues={true}
                        options={alarmStatisticsPCL}
                        value={filters.pcl}
                        onChange={(value) => setFilters(prev => ({...prev, pcl: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        id="alarmType"
                        label='Origem'
                        isMulti={false}
                        wrapValues={true}
                        options={alarmStatisticsType}
                        value={filters.alarmType}
                        onChange={(value) => setFilters(prev => ({...prev, alarmType: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <SelectComponent
                        id="questions"
                        label='Perguntas de alarmes'
                        isMulti={true}
                        wrapValues={true}
                        options={alarmStatisticsQuestions}
                        value={filters.questions}
                        onChange={(value) => setFilters(prev => ({...prev, questions: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <InputCheckbox
                        id="archivedOccurrences"
                        label="Contabilizar ocorrências arquivadas"
                        className={'mb-2 ml-1'}
                        checked={filters.archivedOccurrences}
                        onChange={(e) => setFilters(prev => ({...prev, archivedOccurrences: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="excludeAlarmsAutomaticallySigned"
                        label="Excluir alarmes assinados automaticamente"
                        className={'mb-2 ml-1'}
                        checked={filters.excludeAlarmsAutomaticallySigned}
                        onChange={(e) => setFilters(prev => ({...prev, excludeAlarmsAutomaticallySigned: e.target.checked}))}
                    />

                    <InputCheckbox
                        id="onlyPlateIsExact"
                        label="Alarmes que a leitura da placa confere com a imagem"
                        className={'ml-1'}
                        checked={filters.onlyPlateIsExact}
                        onChange={(e) => setFilters(prev => ({...prev, onlyPlateIsExact: e.target.checked}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;